import { session } from '@openhouse-engineers/oh-js-utils/lib/utils/session'
import { init, setUser, createReduxEnhancer, setTag } from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import { isObjectEmpty } from 'helpers/object'

const initializeSentry = (userDetails, environment) => {
    const blockSentry = ['DEVELOPMENT', 'STAGING', 'BETA'].includes(
        process.env.REACT_APP_CUSTOM_NODE_ENV
    )

    if (blockSentry) return

    init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`,
        environment,
        integrations: [new Integrations.BrowserTracing()],

        // We recommend adjusting this value in production, or using tracesSampler for finer control
        // value ranges between 0 to 1.0, which translates to %age
        // for eg. 0.2 = 20%
        tracesSampleRate: 0.8,
    })

    if (!isObjectEmpty(userDetails)) {
        setUser({
            id: userDetails.userId,
        })
        setTag('userType', userDetails.userType)
        setTag('userName', userDetails.userName)
        setTag('phoneNumber', userDetails.phoneNumber)
    }

    setTag('sessionId', session.get())
}

export const sentryReduxEnhancer = createReduxEnhancer({
    // Optionally pass options
})

export default initializeSentry
